import { RootState } from "../../../redux-store";

export const selectUndispatchedCargos = (state: RootState) =>
  state.data.undispatchedCargos.data;

export const selectUndispatchedCargosRequestState = (state: RootState) =>
  state.data.undispatchedCargos.requestState;